import React, { useState, useEffect } from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'
import {config} from '../../config'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import { validateStrWithNum, validateVal } from '../../utils'

const AddProductStyle = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  // const [Raterowid, setRowId] = useState("");
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [productStyles, setproductStyles] = useState([])
  const [wastages, setWastages] = useState([])
  const [purityData, setpurityData] = useState([])
  const [occasionsData, setoccasionsData] = useState([])
  const [gendersData, setgendersData] = useState([])
  const [mainCategoryParam, setMainCategoryParam] = useState('')
  const [mainSubCategoryParam, setMainSubCategoryParam] = useState('')
  const [name, setName] = useState('')
  const [subCategory_id, setSubCategory_id] = useState('')
  const [category_id, setCategory] = useState('')
  const [productstyle, setProductStyle] = useState('')
  const [wastage, setWastage] = useState('')
  const [purity, setpurity] = useState('')
  const [length, setLength] = useState('')
  const [size, setSize] = useState('')
  const [estimatedDays, setEstimatedDays] = useState('')
  const [occasion, setOccasion] = useState('')
  const [gender, setGender] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  // Save Product style
  const handleProductStyle = () => {
    if (
      !category_id?.trim() ||
      !subCategory_id?.trim() ||
      !name?.trim() ||
      !occasion?.trim() ||
      !gender?.trim() ||
      !purity?.trim() ||
      !wastage?.trim() ||
      // !length?.trim() ||
      // 0 == length?.trim() ||
      // !size?.trim() ||
      // 0 == size?.trim() ||
      // !validateVal([length?.trim(), size?.trim()], validateStrWithNum) ||
      !estimatedDays ||
      !(+estimatedDays > 0) ||
      0 == estimatedDays?.trim()
    ) {
      setError(true);
      return
    }

    const data = {
      category_id: category_id,
      subCategory_id: subCategory_id,
      name: name,
      occasion: occasion,
      gender: gender,
      purity: purity,
      wastage: wastage,
      length: length,
      size: size,
      estimatedDays: estimatedDays,
    }
    const url = config.apiurl + '/prostyle/add'
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('Sub product added successfully')
        setTimeout(() => {
          navigate('/productstyle')
        }, 2000)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
      axios
        .post(url, _.omitBy(data, _.isUndefined), configdata)
        .then(onSuccess, onFailure)
    }

  const getCategory = async () => {
    let catresult = await fetch(config.apiurl + '/category/getcategory')
    catresult = await catresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setCategories(catresult?.data?.results)
  }

  const getSubCategory = async () => {
    let subactresult = await fetch(
      config.apiurl + `/subcategory/${mainCategoryParam}`,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    subactresult = await subactresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setSubCategories(subactresult?.data)
  }
  useEffect(() => {
    getSubCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainCategoryParam])

  const getproductStyles = async () => {
    let productStyleslist = await fetch(
      config.apiurl + `/prostyle/getprolist/`,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    productStyleslist = await productStyleslist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setproductStyles(productStyleslist?.data?.results)
    console.log(productStyleslist?.data?.results)
    console.log(productstyle)
  }

  ///////////////////////GET purityData//////////////////////
  const getpurityData = async () => {
    let purityDatalist = await fetch(config.apiurl + `/purity/getpuritylist`, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    purityDatalist = await purityDatalist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setpurityData(purityDatalist?.data?.results)
    console.log(purityDatalist?.data?.results)
  }

  const getWastageData = async () => {
    let wastagelist = await fetch(config.apiurl + `/wastages/`, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    wastagelist = await wastagelist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setWastages(wastagelist?.data.results)
  }

  ///////////////GET GENDERLIST///////////////////////////
  const getGenderList = async () => {
    let genderResult = await fetch(config.apiurl + `/genderlist/`, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    genderResult = await genderResult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setgendersData(genderResult?.data?.results)
    console.log(genderResult?.data?.results)
  }

  /////////////////////GET OCCASION////////////////////////
  const getOccasion = async () => {
    let occasionlist = await fetch(config.apiurl + `/occasionlist/getocclist`, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    occasionlist = await occasionlist.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setoccasionsData(occasionlist?.data?.results)
    console.log(occasionlist?.data?.results)
  }

  useEffect(() => {
    getCategory()
    getproductStyles()
    getpurityData()
    getWastageData()
    getOccasion()
    getGenderList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlecategory = async (event) => {
    setCategory(event.target.value)
    setMainCategoryParam(event?.target?.value)
    setSubCategory_id('')
  }

  const handleSubCategory = async (event) => {
    setSubCategory_id(event.target.value)
  }

  const handlepurityDataList = async (event) => {
    setpurity(event?.target?.value)
  }

  const handleproductStyles = async (event) => {
    setProductStyle(event?.target?.value)
    setMainSubCategoryParam(event?.target?.value)
  }

  const handleWastgeDatalist = async (event) => {
    setWastage(event?.target?.value)
  }

  const handleOccasion = async (event) => {
    setOccasion(event?.target?.value)
  }

  const handleGender = async (event) => {
    setGender(event?.target?.value)
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Add Sub Product</h6>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                          required
                        >
                          Category
                        </label>
                        <select
                          required
                          className="form-control"
                          value={category_id}
                          onChange={(event) => {
                            handlecategory(event)
                          }}
                        >
                          <option value={""}> Choose </option>
                          {categories.length &&
                            categories.map((item, index) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                        </select>
                        {error && !category_id?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the category name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                          required
                        >
                          Product
                        </label>
                        <select
                          required
                          className="form-control"
                          value={subCategory_id}
                          onChange={(event) => handleSubCategory(event)}
                        >
                          <option value={""}> Choose </option>
                          {subCategories &&
                            subCategories.length &&
                            subCategories.map((item, index) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                        </select>
                        {error && !subCategory_id?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the product name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                          required
                        >
                          Sub Prodcuct
                        </label>
                        <input
                          required
                          className="form-control"
                          type="text"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value)
                          }}
                        />
                        {error && !name?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the sub product name
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Occasion
                        </label>
                        <select
                          required
                          className="form-control"
                          value={occasion}
                          onChange={(event) => {
                            handleOccasion(event)
                          }}
                        >
                          <option value={""}> Choose </option>
                          {occasionsData &&
                            occasionsData.map((item, index) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                        </select>
                        {error && !occasion?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the occasion
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Gender
                        </label>
                        <select
                          required
                          className="form-control"
                          value={gender}
                          onChange={(event) => {
                            handleGender(event)
                          }}
                        >
                          <option value={""}> Choose </option>
                          {gendersData.map((item, index) => (
                            <option value={item._id}>{item.gendername}</option>
                          ))}
                        </select>
                        {error && !gender?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the gender
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Purity
                        </label>
                        <select
                          required
                          className="form-control"
                          value={purity}
                          onChange={(event) => {
                            handlepurityDataList(event)
                          }}
                        >
                          <option value={""}> Choose </option>
                          {purityData &&
                            purityData.map((item, index) => (
                              <option value={item._id}>
                                {item.puritytype}
                              </option>
                            ))}
                        </select>
                        {error && !purity?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the purity
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Wastage
                        </label>
                        <select
                          required
                          className="form-control"
                          value={wastage}
                          onChange={(event) => {
                            handleWastgeDatalist(event)
                          }}
                        >
                          <option value={""}> Choose </option>
                          {wastages &&
                            wastages.map((item, index) => (
                              <option value={item._id}>{item.wastage} %</option>
                            ))}
                        </select>
                        {error && !wastage?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the wastage
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Length
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={length}
                          onChange={(e) => {
                            setLength(e.target.value)
                          }}
                        />
                        {/* {error && (!length?.trim() ||
                            0 == length?.trim() || !validateStrWithNum(length?.trim())) && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the length
                          </span>
                        )} */}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Size
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          value={size}
                          onChange={(e) => {
                            setSize(e.target.value)
                          }}
                        />
                        {/* {error && (!size?.trim() ||
                            0 == size?.trim() || !validateStrWithNum(size?.trim())) && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the size
                          </span>
                        )} */}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Estimated Days
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          min={"1"}
                          value={estimatedDays}
                          onChange={(e) => {
                            setEstimatedDays(e.target.value)
                          }}
                        />
                        {error && (!(+estimatedDays > 0) || !estimatedDays ||
                            0 == estimatedDays?.trim()) && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the estimated days
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <ToastContainer />
                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={handleProductStyle}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default AddProductStyle
